// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"131":"homepage","177":"home","314":"setting","443":"about","831":"education","976":"tool"}[chunkId] || chunkId) + "." + {"10":"4b655687","131":"f6b70f3b","177":"34c51772","314":"f5b9b343","443":"9fab1a2e","831":"a266b923","976":"72cab527"}[chunkId] + ".css";
};